import type {Elements, IContentItem} from '@kontent-ai/delivery-sdk'
import {clsx} from 'clsx'
import type {Block} from '@/services/kontent-ai/types'
import {KontentResponsivePicture} from '@/products/flexible-web-toolkit/components/responsive-picture'
import {getContainerClass} from '../helpers'

export type ArticleHeaderBlockContentItem = IContentItem<{
	image: Elements.AssetsElement
	articleMobileImage: Elements.AssetsElement
	snippetContainerResize: Elements.MultipleChoiceElement
}>

export const ArticleHeaderBlock: Block<ArticleHeaderBlockContentItem> = ({
	block,
}) => {
	const mobileImage = block.elements.articleMobileImage[0]
	const image = block.elements.image[0] ?? mobileImage
	const containerSize = getContainerClass(
		block.elements.snippetContainerResize[0]?.codename ?? '',
		'container-wide'
	)

	return (
		<div className={clsx(containerSize, 'w-full md:flex')}>
			<div className="relative z-20 w-full overflow-hidden rounded-t-lg md:mb-0">
				<KontentResponsivePicture
					className="h-auto w-full object-cover"
					desktopAsset={image}
					fallbackHeight={500}
					fallbackWidth={750}
					fetchPriority="high"
					mobileAsset={mobileImage}
					priority
					quality={65}
					sizes="100vw"
				/>
			</div>
		</div>
	)
}
